import React, { useEffect, useState } from "react";
import { Grid2, Typography, Box } from "@mui/material";
import TargetImg from "../../../Assets/Images/target.png";
import CongratsBg from "../../../Assets/Images/Signup_web.png";
import Logo from '../../../Assets/Images/logo.svg';
import finalCgs from "./Final_Congrats.module.css"
import Swal from 'sweetalert2'
import { finalCall, setClientIdRx, setCongratsStatus, setEsignStatus } from "../../../Redux/usersSlice";
import { useDispatch, useSelector } from "react-redux";
import collab from '../../../Assets/Images/collab1.svg';

const Congrats = () => {
   const { loading, userData,cleint_id,source } = useSelector(state => state.user);
   const dispatch=useDispatch()

   const [clientId,setClientId]=useState("")

useEffect(() => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "kyc_step_viewed",
    step_name: "congrats_page_viewed",
    page_path: window.location.pathname
  });
    const fetchData = async () => {
        try {
            // Check if the data has already in redux store
            // const isFetched = localStorage.getItem("clientDataFetched");
            // const isEsignDone=userData?.steps?.["Esign"]?.status

            
            const isCongratsDone=userData?.steps?.["Congrats Page"]?.status

            // console.log("CC",isCongratsDone)
           
            if (!isCongratsDone) {
              console.log("inside")
                const response = await dispatch(finalCall({
                  email: userData.email.toLowerCase(),
                    mobile: userData.mobile
                })).unwrap();
                
                console.log("Response:", response);
                setClientId(response.data.data.client_id);
                dispatch(setCongratsStatus())
                // dispatch(setEsignStatus())
                
                // Mark as fetched
                // localStorage.setItem("clientDataFetched", "true");
                dispatch(setClientIdRx(response.data.data.client_id))
            }else{
             console.log(userData.client_id)
            //  console.log(!userData.client_id)
             setClientId(userData.client_id)
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };
    
    fetchData();
}, []);


  return (
    <main>
    <Grid2
      container
      sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: `url(${CongratsBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          overflowX: "hidden",
          "@media (max-width:450px)": {
              justifyContent: "start"
          }
      }}
    >
      <img
          src={Logo}
          src={source == "cosmos" ? collab : Logo}
          alt="Logo"
          className={source == "cosmos" ? finalCgs.twologo : finalCgs.logo}
        style={{ marginBottom: source == "cosmos" ? "" : "15px", marginTop:"10px" }} // Adjust width & spacing as needed
      />
      {
        source == "cosmos" &&
        <Typography className={finalCgs.txt1}>
          Together with Tradeboss, CFG India simplifies Investing in Listed/ Unlisted securities.
        </Typography>
      }
      <Typography
        sx={{
          fontFamily: "Inter900",
                  fontSize: "52px",
                  color: "#481B9D",
                  marginBottom: "38px",
                  textAlign: "center",
                  '@media (max-width: 1300px)': {
                      fontSize: '42px',
                      marginBottom: '28px',
                      paddingLeft: "24px",
                      paddingRight: "24px"
                  },
                  '@media (max-width: 900px)': {
                      fontSize: '32px',
                      marginBottom: '20px',
                      paddingLeft: "24px",
                      paddingRight: "24px"
                  },
                  '@media (max-width: 600px)': {
                      fontSize: '24px',
                      marginBottom: '16px',
                      paddingLeft: "24px",
                      paddingRight: "24px"
                  },
        }}
          className={finalCgs.heading}
      >
        You've Completed All Steps!
      </Typography>

      <Typography
       sx={{
          mb: "42px", fontFamily: "Inter400", fontSize: "24px", textAlign: "center", '@media (max-width: 1300px)': {
                          fontSize: '20px',
                          mb: '24px',
                          paddingLeft: "24px",
                          paddingRight: "24px"
                      },
                      '@media (max-width: 900px)': {
                          fontSize: '18px',
                          mb: '24px',
                          paddingLeft: "24px",
                          paddingRight: "24px"
                      },
                      '@media (max-width: 600px)': {
                          fontSize: '16px',
                          mb: '18px',
                          paddingLeft: "24px",
                          paddingRight: "24px"
                      },
                  
                 
       }}
        className={finalCgs.title1}
      >
        Congratulations, You Are One Of Us Now.
      </Typography>

      <Box sx={{ marginBottom: "32px" }}>
        <img
          src={TargetImg} // Import this at the top of your file
          alt="Target icon"
          style={{
            width: "281px",
            height: "262px",
            margin: "0 auto",
            display: "block",
          }}
           className={finalCgs.success}
        />
      </Box>
        

      <Typography
        sx={{
          fontFamily: "Inter900",
                  fontSize: "32px",
                  color: "#481B9D",
                  marginBottom: "38px",
                  textAlign: "center",
                  '@media (max-width: 1300px)': {
                      fontSize: '22px',
                      marginBottom: '28px',
                      paddingLeft: "24px",
                      paddingRight: "24px"
                  },
                  '@media (max-width: 900px)': {
                      fontSize: '20px',
                      marginBottom: '20px',
                      paddingLeft: "24px",
                      paddingRight: "24px"
                  },
                  '@media (max-width: 600px)': {
                      fontSize: '16px',
                      marginBottom: '16px',
                      paddingLeft: "24px",
                      paddingRight: "24px"
                  },
        }}
         className={finalCgs.heading1}
      >
        {`Your Client Code Is: ${loading ? "Processing..." : clientId || cleint_id}`}
      </Typography>

          <Typography
              sx={{
                  mb: "52px", fontFamily: "Inter400", fontSize: "24px", textAlign: "center", '@media (max-width: 1300px)': {
                      fontSize: '20px',
                      mb: '24px',
                      paddingLeft: "24px",
                      paddingRight: "24px"
                  },
                  '@media (max-width: 900px)': {
                      fontSize: '18px',
                      mb: '24px',
                      paddingLeft: "24px",
                      paddingRight: "24px"
                  },
                  '@media (max-width: 600px)': {
                      fontSize: '16px',
                      mb: '24px',
                      paddingLeft: "24px",
                      paddingRight: "24px"
                  },
              }}
              className={finalCgs.title2}

          >
        We Will Notify You Once Your Account Ready For Trade
      </Typography>
    </Grid2>
    </main>
  );
};

export default Congrats;
